import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { AiFillMail, AiFillPhone, AiFillPushpin } from "react-icons/ai";

import datas from "../local-json/datas"
import { Carousel, Footer, Blob } from '../components';


const Home = () => {
  return (
    <>
      <Helmet>
        <title>Instants de Soie - Prothésiste ongulaire à La Ville-Dieu-du-Temple</title>
        <meta name="description" content="Instants de Soie, prothésiste ongulaire et esthéticienne à La Ville-Dieu-du-Temple (82290). Manucure, extension d'ongles, semi-permanent, soins visage." />
        <link rel="canonical" href="https://instantsdesoie.fr/" />
      </Helmet>
      <div id='Home' className='bg-main-bg h-100 pt-1'>
        <div className='homeContainer mt-4'>
          <div className='heroHome pl-12 xs:pl-0'>
            <div className='homeLeft'>
              <h1 className='mainTitle'>Prothésiste ongulaire</h1>
              <div className='secondTitle'>
                <p>Belle</p>
                <p>jusqu'au bout des</p>
                <p><span>ongles</span><span> !</span></p>
              </div>
              
              <div className='Buttons horizontal'>
                <a className='button black' href='https://www.rdv360.com/instants-de-soie?fbclid=IwAR3SL_6ZlQz5W_hsBfEJoTodcLyMwFtXlmCDHzTVrwDPT1WwnI57h95A10c' target="_blank" rel="noopener noreferrer" aria-label="Prendre rendez-vous">Prendre RDV</a>
                <Link className='button transparent' to="/benefit">Prestation</Link>
              </div>

              <div className='contactListingMenu'>
                <ul>
                  <li><span><AiFillPushpin /></span>
                    <div>
                      <span>{datas.address1}</span>
                      <span>{datas.address2}</span>
                    </div>
                  </li>
                  <li><span><AiFillPhone /></span>{datas.number}</li>
                  <li><span><AiFillMail /></span>{datas.mail}</li>
                </ul>
              </div>
            </div>
            <div className='homeRight'>
              <div className='hero-img'>
                <img src={`./img/hands/hand-hero.webp`} alt="Manucure rouge femme - Instants de Soie" loading="lazy" width="3840" height="5760"/>
              </div>
            </div>
          </div>

          <div className='aboutHome bg-second-bg pl-12 xs:pl-0'>
            <div className='aboutContent'>
              <div className='aboutTitle'>
                <h2 className='textBlob'>A propos de moi 
                  <Blob />
                </h2>
              </div>
              <div className='aboutSubtitle'>
                <h2>Votre Beauté est Ma Priorité</h2>
              </div>
              <div className='aboutDescription'>
                <h3>Esthéticienne diplômée à Skhole d'Art & formé en prothésie ongulaire. Je sublime vos ongles avec des produits de qualité fabriqués en France de la marque Créa'Ongles Distribution qui assure qualité et respect des normes Européennes.</h3>
              </div>
            </div>
            <div className='aboutSvg svg'>
              <img src='./img/svg/olive-branch.svg' alt="image de branche d'olivier"/>
            </div>
          </div>
          <div className='slider bg-second-bg'>
            <div className='sliderContainer'>
              <div className='sliderSvg svg'>
                <img src="./img/svg/willow-branch.svg" alt="image de plante" />
              </div>
              <Carousel />
            </div>
          </div>
          {/* <div className='testimonial bg-second-bg py-20 pl-12 xs:pl-0'>
              <div className='testimonialContainer'>
                <div className='testimonialSvgLeft svg'>
                  <img src="./img/svg/leaves-on-a-branch-diagonal-shape.svg" alt="image de plante Ongles Manucure" />
                </div>
                <div className='testimonialSvgRight svg'>
                  <img src="./img/svg/leaves-on-a-branch-silhouette.svg" alt="image de plante Ongles Manucure" />
                </div>
                
                <Testimonial />
              </div>
            </div> */}
        </div>
        <div className='footer bg-dark-bg'>
          <Footer datas={datas}/>
        </div>
      </div>
    </>
  )
}

export default Home